// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1cc9L","bigColWidth":"Table_bigColWidth__1UtIa","biggerColWidth":"Table_biggerColWidth__3THEE","row":"Table_row__3QGFo","col":"Table_col__1jgA_"};